import Button from "@mui/material/Button";
import * as MuiIcons from "@mui/icons-material";

//Possible variants - text, contained, outlined
function PrimaryButton({
  label,
  variant = "outlined",
  startIcon = null,
  endIcon = null,
  onClick = () => {},
  sx = {},
  size = "medium",
  disabled,
}) {
  const generateIcon = (variation, props = {}) => {
    const IconName = MuiIcons[variation];
    return <IconName {...props} />;
  };

  return (
    <Button
      variant={variant}
      startIcon={startIcon ? generateIcon(startIcon) : null}
      endIcon={endIcon ? generateIcon(endIcon) : null}
      onClick={onClick}
      sx={sx}
      size={size}
      disabled={disabled}
    >
      {label}
    </Button>
  );
}

export default PrimaryButton;
